import LineItemCreditItem from "../../Domain/CreditMemo/LineItemCreditItem";
import SearchParams from "../../Elements/SearchParams";
import LineItemCreditSearchParams from "../../Contents/Operations/CreditMemo/LineItemCreditSearchParams";
import AuthService from "../authService";

export default class LineItemCreditService {
    static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
        let authService = AuthService.getInstance();

        let url = "/api/LineItemCredit/GetAllBySearchingAsync?";

        let searchParams = new SearchParams(searchItem, LineItemCreditSearchParams, orderById, orderDir, pageNumber, numberOfElements);
        url += "searchParams=" + searchParams.serializeForBackendCall();
        url += "&clearCache=" + clearCache;

        return authService.CallBackendFunction(url);
    }

    static ConvertDBItemList(items) {
        var convertedItems = [];

        if (items !== null) {
            items.forEach(item => {
                var newItem = new LineItemCreditItem(item);
                convertedItems.push(newItem);
            });
        }

        return convertedItems;
    }
}